// What production shows while the app is tested on dev. Deliberately nothing
// else: no sign-in, no link to the app, and no call to the database.
// vite.config.ts picks this or the app from a switch set per branch in deploy.yml.
export default function ComingSoon() {
  return (
    <div className="pad">
      <p className="brand" style={{ margin: "24px 0 8px" }}>
        <span className="brand-dot" aria-hidden />
        <span className="brand-name">Reset</span>
      </p>
      <h1>Field Observation</h1>
      <p><span className="role">Coming soon</span></p>
    </div>
  );
}
